import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { IAuthReduxProps, IBudgetTable0, ITarget } from '../../types/interfaces';

import TableContainer from "../tables_manager/TableContainer"
// import BudgetEdit from '../goal/BudgetEdit';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faCommentDots, faEdit, faExclamationTriangle, faEyeSlash, faEye } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants'
import { PRIVILEGE } from '../../types/privileges';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';

const BudgetTable = ({ 
  linesData,
  budgets,
  auth
 }: IBudgetTable0) => {
  const [budgetsEditModal, setBudgetsEditModal] = useState(false);
  const [budgetsEditMonth, setBudgetsEditMonth] = useState<any>(undefined);
  const [societeValue, setSocieteValue] = useState<any>(undefined);

  const getBudgetsFromDate = (month: number, year: number) => {
    if(societeValue && societeValue?.id !== "ALL")
      return budgets.find(e => e.societeId === societeValue.id && e.month === month && e.year === year)
    return undefined
  }

  const months = constants.DP_MONTHS.map((e, i) => ({
    Header: e,
    columns: [
      {
        Header: "Réalisé",
        id: "Réalisé" + String(i + 1),
        accessor: String(i + 1),
        //custom export..
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ value }) => <div className="monthCardContent" style={{minWidth: "150px"}}>
          <div><b>Encaissements :</b></div>
          <div>{value?.sEncaissements ? `${value.sEncaissements.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
          <div><b>Ventes :</b></div>
          <div>{value?.sPrixNet ? `${value.sPrixNet.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
        </div>
      },
      {
        Header: "Budget",
        id: "Budget" + String(i + 1),
        accessor: String(i + 1),
        //custom export..
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ value, row: {original} }) => <div className="monthCardContent" style={{minWidth: "150px"}}>
          <div><b>Encaissements :</b></div>
          <div>{value?.goalE ? `${value.goalE.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
          <div><b>Ventes :</b></div>
          <div>{value?.goalV ? `${value.goalV.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
          {!!value?.comment && <>
            <FontAwesomeIcon icon={faCommentDots} className="monthCardBtnIcon monthCardComment" data-tip data-for={`comment_tooltip_ob${i}`} />
            <ReactTooltip effect="solid" id={`comment_tooltip_ob${i}`} type={"dark"}>
              {value?.comment}
            </ReactTooltip>
          </>}
          {!!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_BUDGETS) && <FontAwesomeIcon icon={faEdit} className="monthCardBtnIcon monthCardEdit" title="Modifier les objectifs budget de ce mois" onClick={() => {setSocieteValue({id: original.projectId, LIBELE: original.projectName}); setBudgetsEditMonth({month: value?.month, year: value?.year}); setBudgetsEditModal(true);}} />}
        </div>
      },
      {
        Header: "Écart",
        id: "Écart" + String(i + 1),
        accessor: String(i + 1),
        //custom export..
        disableSortBy: true,
        disableFilters: true,
        Cell: ({ value }) => <div className="monthCardContent" style={{minWidth: "150px"}}>
          <div><b>Encaissements :</b></div>
          <div>{value?.goalE ? `${((value.sEncaissements || 0) - value.goalE).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
          <div><b>Ventes :</b></div>
          <div>{value?.goalV ? `${((value.sPrixNet || 0) - value.goalV).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} DH` : "-"}</div>
        </div>
      },
      {
        Header: "%",
        id: "%" + String(i + 1),
        accessor: String(i + 1),
        //custom export..
        disableSortBy: true,
        disableFilters: true,
        className: "tableCellRightBorder",
        Cell: ({ value }) => <div className="monthCardContent" style={{minWidth: "150px"}}>
          <div><b>Encaissements :</b></div>
          <div className="encPercent" style={{color: "hsl(" + (Math.ceil(((value.sEncaissements || 0) * 100) / value.goalE) * 1.2).toString(10) + ", 100%, 50%)"}}>{value?.goalE ? `${Math.ceil(((value.sEncaissements || 0) * 100) / value.goalE)} %` : "-"}</div>
          <div><b>Ventes :</b></div>
          <div className="encPercent" style={{color: "hsl(" + (Math.ceil(((value.sPrixNet || 0) * 100) / value.goalV) * 1.2).toString(10) + ", 100%, 50%)"}}>{value?.goalV ? `${Math.ceil(((value.sPrixNet || 0) * 100) / value.goalV)} %` : "-"}</div>
        </div>
      },
    ]
  }))

  const columns = useMemo(
    () => [
      {
        Header: "",
        accessor: "projectName",
        className: "tableLeftHeader tableStickyColumn",
        disableSortBy: true,
        // disableFilters: true,
        Cell: ({ value, row: {original} }) => value
      },
      ...months
    ],
    []
  )

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={linesData} enableCheckBox={false} isEditable={false} centerCols hideFirstCol SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      {/* <BudgetEdit modal={budgetsEditModal} setModal={setBudgetsEditModal} modalData={budgetsEditMonth} societeGoal={societeValue} getBudgetsFromDate={getBudgetsFromDate} /> */}
    </div>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error,
});

export default connect(mapStateToProps, {})(BudgetTable);
